import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../css/Navbar.css';
import { ShoppingCart } from 'lucide-react';
import logo from '../Images/redfibre logo.png';

const Navbar = ({ page }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const App = () => {
    return (
      <ShoppingCart />
    );
  };

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  const descriptions = ["Strategy", "Design", "Development", "Motion", "Social"];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % descriptions.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="navbar-container">
      <div className="navbar-section logo-box">
        {/* ✅ Logo wrapped in Link to "/" */}
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src={logo} className="rf" alt="Redfibre Logo" />
          <div className="desBox">
            <div
              className="des"
              style={{ transform: `translateY(-${currentIndex * 100}%)` }}
            >
              {descriptions.map((desc, i) => (
                <div className="de" key={i}>{desc}</div>
              ))}
            </div>
          </div>
        </Link>

        <div className="hamburger" onClick={toggleMenu}>
          <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
          <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
          <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
        </div>
      </div>

      <div className={`navbar-section1 menu-box ${menuOpen ? 'show-menu' : ''}`}>
        <div className="close-button" onClick={closeMenu}>×</div>
        <div className="nav-links">
          <Link
            to="/services"
            className={page === "serv" ? "active" : ""}
            onClick={closeMenu}
          >
            SERVICES
          </Link>
          <Link
            to="/solutions"
            className={page === "sol" ? "active" : ""}
            onClick={closeMenu}
          >
            SOLUTIONS
          </Link>
          <Link
            to="/contact"
            className={page === "cont" ? "active" : ""}
            onClick={closeMenu}
          >
            CONTACT
          </Link>
          {/* <Link
            to="/blogpage"
            className={page === "cont" ? "active" : ""}
            onClick={closeMenu}
          >
            Blogs
          </Link> */}
          <Link
            to="/comingsoon"
            className={page === "prof" ? "active" : ""}
            onClick={closeMenu}
          >
            PROFILE
          </Link>
          <Link to="/cart" className="cart-icon" onClick={closeMenu}>
           <ShoppingCart size={20} color="#fff" />
          
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
